import styled from 'styled-components'
import { ScoreVariant } from './ScoreDisplay.types'
import { media } from '../../../utils/mediaQuery'

export const Container = styled.div<{
  $variant?: ScoreVariant
  $withProgress?: boolean
  $clickable?: boolean
}>`
  display: flex;
  align-items: ${({ $withProgress }) =>
    $withProgress ? 'stretch' : 'baseline'};
  flex-direction: ${({ $withProgress }) => ($withProgress ? 'column' : 'row')};
  gap: ${({ $withProgress }) => ($withProgress ? '6px' : '10px')};
  padding: 3px 16px;
  background: ${({ theme }) => theme.colors.background.tertiary};
  border-radius: 6px;
  transition: all 0.2s ease;
  cursor: ${({ $clickable }) => ($clickable ? 'pointer' : 'default')};

  &:hover {
    box-shadow: ${({ theme }) => theme.shadows.sm};
  }

  ${media.tabletDown} {
    width: 100%;
    justify-content: center;
  }
`

export const ScoreContainer = styled.div`
  display: flex;
  align-items: baseline;
  gap: 3px;
`

export const ScoreValue = styled.span<{ $variant?: ScoreVariant }>`
  font-size: 26px;
  font-weight: 600;
  color: ${({ theme, $variant }) => {
    switch ($variant) {
      case 'warning':
        return theme.colors.warning
      case 'success':
        return theme.colors.success
      case 'danger':
        return theme.colors.danger
      case 'primary':
        return theme.colors.primary
      default:
        return theme.colors.text.primary
    }
  }};

  ${media.tabletDown} {
    font-size: 28px;
  }
`

export const ScoreMax = styled.span`
  font-size: 13px;
  color: ${({ theme }) => theme.colors.text.secondary};

  ${media.tabletDown} {
    font-size: 14px;
  }
`

export const ScoreLabel = styled.div`
  font-size: 11px;
  color: ${({ theme }) => theme.colors.text.secondary};
  display: flex;
  align-items: center;
  flex-wrap: wrap;

  @media (max-width: 480px) {
    font-size: 12px;
  }
`

export const ProgressBarContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`

export const ProgressBar = styled.div`
  height: 3px;
  background: rgba(0, 0, 0, 0.1);
  border-radius: 2px;
  overflow: hidden;
  width: 100%;
  align-self: stretch;
`

export const ProgressFill = styled.div<{
  $variant?: ScoreVariant
  $width: number
}>`
  height: 100%;
  background: ${({ theme, $variant }) => {
    switch ($variant) {
      case 'warning':
        return theme.colors.warning
      case 'success':
        return theme.colors.success
      case 'danger':
        return theme.colors.danger
      case 'primary':
        return theme.colors.primary
      default:
        return theme.colors.primary
    }
  }};
  transition: width 0.6s ease;
  border-radius: 2px;
  width: ${({ $width }) => $width}%;
`
